/**
 * Den vollständigen Stand als Datei ausgeben.
 *
 * Zwei Zwecke: Notausgang, falls der Browser die Datenbank abräumt — Safari auf
 * iOS tut das nach sieben Tagen ohne Nutzung —, und Grundlage für den
 * automatischen Weg in den Cloud-Ordner (Teilprojekt 5).
 *
 * Das Format ist dasselbe wie beim Bundle, ergänzt um die Grabsteine. Damit
 * liest `laden.js:uebernimm()` den Abzug ohne Sonderweg wieder ein.
 *
 * `mitProfilen: false` lässt die Messpunkte weg — für den Geräteabgleich, wo
 * sie 95 Prozent der Datenmenge ausmachen und sich nie ändern. Der Datei-Abzug
 * nimmt sie mit, denn er ist die Sicherung.
 */

import { SPEICHER, alleAus, alleTauchgaenge, messpunkte } from './db.js';
import { FORMAT } from './laden.js';
import { grabsteine } from './saetze.js';

export async function baueAbzug(db, { mitProfilen = true } = {}) {
  const kopfdaten = await alleTauchgaenge(db);
  const dives = [];
  for (const kopf of kopfdaten) {
    const werte = mitProfilen && kopf.has_profile ? await messpunkte(db, kopf.id) : null;
    dives.push(werte ? { ...kopf, samples: werte } : { ...kopf });
  }
  return {
    format: FORMAT,
    erzeugt: new Date().toISOString(),
    dives,
    sites: await alleAus(db, SPEICHER.sites),
    trips: await alleAus(db, SPEICHER.trips),
    buddies: await alleAus(db, SPEICHER.buddies),
    gear: await alleAus(db, SPEICHER.gear),
    grabsteine: await grabsteine(db),
  };
}

export function dateiname(datum = new Date()) {
  return `tauchlogbuch-${datum.toISOString().slice(0, 10)}.json`;
}
